import axios from "axios";

const urlMapper = {
  getUserPc: "/smzy/shspace/loginsso/getuser",
  getUserOc: "/qykj/shspace/loginsso/getuser"
};
export const userType = {
  tourist: "游客",
  person: "个人",
  enterprise: "法人"
};
const userTypeCode = {
  person: 0,
  enterprise: 1
};
// 域名
const domain = `${PUBLICENV || ""}`;
// 万达登录验证
const wandaLoginUrl = "https://zwdtuser.sh.gov.cn/uc/login/login.jsp";
const loginCheckUrl = {
  [userType.person]: url => {
    const redirect = `${domain}/smzy/shspace/loginsso/in?type=bsgr&callback=${encodeURIComponent(
      url
    )}`;
    return `${wandaLoginUrl}?redirect_uri=${encodeURIComponent(redirect)}`;
  },
  [userType.enterprise]: url => {
    const redirect = `${domain}/qykj/shspace/loginsso/in?type=bsfr&callback=${encodeURIComponent(
      url
    )}`;
    return `${wandaLoginUrl}?redirect_uri=${encodeURIComponent(redirect)}`;
  },
  [userType.tourist]: url => {
    const redirect = `${domain}/smzy/shspace/loginsso/in?type=bsgrfr&callback=${encodeURIComponent(
      url
    )}`;
    return `${wandaLoginUrl}?redirect_uri=${encodeURIComponent(redirect)}`;
  }
};

export default {
  namespaced: true,
  state: {
    userType: userType.tourist
  },
  getters: {},
  mutations: {
    setUserType(state, userType) {
      state.userType = userType;
    }
  },
  actions: {
    checkCurrentUserType({ commit }) {
      return axios
        .all([
          axios.get(urlMapper.getUserPc, {
            data: "noredirect"
          }),
          axios.get(urlMapper.getUserOc, {
            data: "noredirect"
          })
        ])
        .then(
          axios.spread((personal, enterprise) => {
            const resPc = personal.data,
              resOc = enterprise.data;
            let curUserType = userType.tourist;
            if (
              resPc.issuccess === "true" &&
              parseInt(resPc.type, 10) === userTypeCode.person
            ) {
              curUserType = userType.person;
            } else if (
              resOc.issuccess === "true" &&
              parseInt(resOc.type, 10) === userTypeCode.enterprise
            ) {
              curUserType = userType.enterprise;
            }
            commit("setUserType", curUserType);
            return curUserType;
          })
        );
    },
    redirectWithLoginCheck({}, { type = userType.tourist, url }) {
      return loginCheckUrl[type](url);
    }
  }
};

export function changeOcUrlToPcUrl(urlMapper) {
  Object.keys(urlMapper).forEach(key => {
    const url = urlMapper[key];
    urlMapper[key] = url.replace(/qykj/g, "smzy");
  });
}



// WEBPACK FOOTER //
// ../src/pages/main/store/common/user.js